import React, { useState, useEffect } from "react";
import {
  Tabs,
  Tab,
  Grid,
  Card,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { collection, getDocs, updateDoc, deleteDoc, doc, setDoc } from "firebase/firestore";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { firestore, auth } from "firebaseConfig";
import { useMaterialUIController } from "context";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Categorias padrão para novos usuários (alinhado com Firestore)
const categoriasPadrao = [
  { nome: "Salário", emoji: "💰", tipo: "Receita" },
  { nome: "Freelance", emoji: "🧑‍💻", tipo: "Receita" },
  { nome: "Rendimento de Investimentos", emoji: "📈", tipo: "Receita" },
  { nome: "Bônus", emoji: "🎉", tipo: "Receita" },
  { nome: "Produtividade", emoji: "📊", tipo: "Receita" },
  { nome: "Salário Estado", emoji: "🏛️", tipo: "Receita" },
  { nome: "Salário Português", emoji: "🇵🇹", tipo: "Receita" },
  { nome: "Aluguel", emoji: "🏠", tipo: "Despesa Fixa" },
  { nome: "Internet", emoji: "🌐", tipo: "Despesa Fixa" },
  { nome: "Energia Elétrica", emoji: "💡", tipo: "Despesa Fixa" },
  { nome: "Plano de Saúde", emoji: "🏥", tipo: "Despesa Fixa" },
  { nome: "Acordo Receita Federal", emoji: "📜", tipo: "Despesa Fixa" },
  { nome: "Personal", emoji: "🏋️", tipo: "Despesa Fixa" },
  { nome: "Combustível", emoji: "⛽", tipo: "Despesa Fixa" },
  { nome: "Especialização Carol", emoji: "🎓", tipo: "Despesa Fixa" },
  { nome: "Academia Marcos", emoji: "💪", tipo: "Despesa Fixa" },
  { nome: "Academia Carol", emoji: "💪", tipo: "Despesa Fixa" },
  { nome: "Consultoria financeira", emoji: "💼", tipo: "Despesa Fixa" },
  { nome: "Gympass", emoji: "🏋️", tipo: "Despesa Fixa" },
  { nome: "Plano de saúde Carol", emoji: "🏥", tipo: "Despesa Fixa" },
  { nome: "Seguro do imóvel", emoji: "🏠", tipo: "Despesa Fixa" },
  { nome: "Alimentação", emoji: "🍽️", tipo: "Despesa Variável" },
  { nome: "Transporte", emoji: "🚗", tipo: "Despesa Variável" },
  { nome: "Lazer", emoji: "🎭", tipo: "Despesa Variável" },
  { nome: "Restaurantes", emoji: "🍴", tipo: "Despesa Variável" },
  { nome: "Mercado", emoji: "🛒", tipo: "Despesa Variável" },
  { nome: "Itens pessoais/vestuário", emoji: "👗", tipo: "Despesa Variável" },
  { nome: "Uber/99", emoji: "🚖", tipo: "Despesa Variável" },
  { nome: "Hospedagem", emoji: "🏨", tipo: "Despesa Variável" },
  { nome: "Fatura cartão valor menor", emoji: "💳", tipo: "Despesa Variável" },
  { nome: "Outros", emoji: "📦", tipo: "Despesa Variável" },
  { nome: "Farmácia", emoji: "💊", tipo: "Despesa Variável" },
];

function PainelAdmin() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [tabIndex, setTabIndex] = useState(0);
  const [modalTabIndex, setModalTabIndex] = useState(0);
  const [usuarios, setUsuarios] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showEditUserDialog, setShowEditUserDialog] = useState(false);
  const [showDeleteUserDialog, setShowDeleteUserDialog] = useState(false);
  const [showNewUserDialog, setShowNewUserDialog] = useState(false);
  const [showViewUserDialog, setShowViewUserDialog] = useState(false);
  const [showLinkClientsDialog, setShowLinkClientsDialog] = useState(false);
  const [allClients, setAllClients] = useState([]);
  const [linkedClients, setLinkedClients] = useState([]);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const [userDetails, setUserDetails] = useState({
    lancamentos: [],
    metas: [],
    investimentos: [],
  });
  const [filteredData, setFilteredData] = useState([]);
  const [newUser, setNewUser] = useState({
    name: "",
    email: "",
    password: "",
    role: "cliente",
  });

  const [usuariosFiltrados, setUsuariosFiltrados] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    fetchUsuarios();
  }, []);

  useEffect(() => {
    setUsuariosFiltrados(usuarios);
  }, [usuarios]);

  const exportToPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.setTextColor(40, 40, 40);
    doc.text("Relatório de Usuário", 10, 10);
    if (selectedUser?.name) {
      doc.setFontSize(14);
      doc.text(`Usuário: ${selectedUser.name}`, 10, 20);
    }

    let currentY = 30;
    const tableColors = {
      lancamentos: [0, 86, 100],
      metas: [128, 0, 128],
      investimentos: [138, 43, 226],
      rowAlternate: [240, 240, 240],
    };

    const filteredLancamentos = filteredData.filter((lancamento) => {
      if (!lancamento.data) return false;
      const [dia, mes, ano] = lancamento.data.split("/");
      const lancamentoDate = new Date(`${ano}-${mes}-${dia}T00:00:00`);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      return (!start || lancamentoDate >= start) && (!end || lancamentoDate <= end);
    });

    doc.setFontSize(16);
    doc.setTextColor(...tableColors.lancamentos);
    doc.text("Lançamentos", 10, currentY);
    currentY += 10;

    const tipos = ["Receita", "Despesa Fixa", "Despesa Variável", "Outros"];
    tipos.forEach((tipo) => {
      const lancamentosPorTipo = filteredLancamentos.filter((l) => l.tipo === tipo);
      if (lancamentosPorTipo.length > 0) {
        const categoriasUnicas = [...new Set(lancamentosPorTipo.map((l) => l.categoria))];
        categoriasUnicas.forEach((categoria) => {
          const lancamentosCategoria = lancamentosPorTipo.filter((l) => l.categoria === categoria);
          doc.setFontSize(14);
          doc.setTextColor(0, 0, 0);
          doc.text(
            `${
              tipo === "Receita"
                ? "Receitas"
                : tipo === "Despesa Fixa"
                ? "Despesas Fixas"
                : tipo === "Despesa Variável"
                ? "Despesas Variáveis"
                : "Outros"
            } - ${categoria || "Sem categoria"}`,
            10,
            currentY
          );
          currentY += 8;
          autoTable(doc, {
            startY: currentY,
            head: [["Data", "Categoria", "Forma de Pagamento", "Valor", "Status"]],
            body: lancamentosCategoria.map((lancamento) => [
              lancamento.data ? lancamento.data : "Não informado",
              lancamento.categoria || "Não informado",
              lancamento.formaPagamento || "Não informado",
              lancamento.valor || "R$ 0,00",
              "Pago",
            ]),
            theme: "grid",
            headStyles: { fillColor: tableColors.lancamentos, textColor: 255 },
            bodyStyles: { fillColor: [255, 255, 255], textColor: 0 },
            alternateRowStyles: { fillColor: tableColors.rowAlternate },
          });
          currentY = doc.lastAutoTable.finalY + 10;
        });
      }
    });

    doc.setFontSize(16);
    doc.setTextColor(...tableColors.metas);
    doc.text("Metas", 10, currentY);
    currentY += 10;
    autoTable(doc, {
      startY: currentY,
      head: [["Meta", "Valor", "Total Aportado", "Prazo", "Dias Restantes"]],
      body: userDetails.metas.map((meta) => [
        meta.nome || "Não informado",
        `R$ ${meta.valor?.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) || "0,00"}`,
        `R$ ${
          meta.aportesRegistrados
            ? meta.aportesRegistrados
                .reduce((total, aporte) => total + aporte, 0)
                .toLocaleString("pt-BR", { minimumFractionDigits: 2 })
            : "0,00"
        }`,
        meta.prazo ? new Date(meta.prazo).toLocaleDateString("pt-BR") : "Não informado",
        meta.prazo
          ? Math.max(Math.ceil((new Date(meta.prazo).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)), 0) +
            " dias"
          : "Não informado",
      ]),
      theme: "grid",
      headStyles: { fillColor: tableColors.metas, textColor: 255 },
      bodyStyles: { fillColor: [255, 255, 251], textColor: 0 },
      alternateRowStyles: { fillColor: tableColors.rowAlternate },
    });

    currentY = doc.lastAutoTable.finalY + 10;

    doc.setFontSize(16);
    doc.setTextColor(...tableColors.investimentos);
    doc.text("Investimentos", 10, currentY);
    currentY += 10;
    autoTable(doc, {
      startY: currentY,
      head: [["Categoria", "Ativo", "Corretora", "Data", "Quantidade", "Valor Aplicado", "Indexador", "Taxa"]],
      body: userDetails.investimentos.map((investimento) => [
        investimento.categoria || "Não informado",
        investimento.ativo || "Não informado",
        investimento.corretora || "Não informado",
        investimento.data ? new Date(investimento.data).toLocaleDateString("pt-BR") : "Não informado",
        investimento.quantidade || "0",
        `R$ ${investimento.valorAplicado?.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) || "0,00"}`,
        investimento.indexador || "Não informado",
        `${investimento.taxa || "0"}%`,
      ]),
      theme: "grid",
      headStyles: { fillColor: tableColors.investimentos, textColor: 255 },
      bodyStyles: { fillColor: [255, 255, 255], textColor: 0 },
      alternateRowStyles: { fillColor: tableColors.rowAlternate },
    });

    doc.save(`${selectedUser?.name || "Relatório"}.pdf`);
  };

  const fetchUsuarios = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, "usuarios"));
      const usersList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        linkedClients: doc.data().linkedClients || [],
      }));
      setUsuarios(usersList);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error.message);
    }
  };

  const fetchAllClients = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, "usuarios"));
      const clients = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setAllClients(clients);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error.message);
    }
  };

  const fetchUserDetails = async (userId) => {
    try {
      const lancamentosSnap = await getDocs(collection(firestore, "usuarios", userId, "lancamentos"));
      let lancamentos = lancamentosSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Filter only paid transactions
      lancamentos = lancamentos.filter((lancamento) => lancamento.pago === true);

      // Log the raw lancamentos for debugging
      console.log("Raw lancamentos (after filtering for pago: true):", lancamentos);

      // Associar tipo aos lançamentos baseado na categoria
      lancamentos = lancamentos.map((lancamento) => {
        const categoriaEncontrada = categoriasPadrao.find((cat) => cat.nome === lancamento.categoria);
        const tipo = categoriaEncontrada ? categoriaEncontrada.tipo : "Outros";
        return {
          ...lancamento,
          tipo,
          categoria: lancamento.categoria || "Sem categoria",
        };
      });

      const metasSnap = await getDocs(collection(firestore, "usuarios", userId, "metas"));
      const metas = metasSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const investimentosSnap = await getDocs(collection(firestore, "usuarios", userId, "investimentos"));
      const investimentos = investimentosSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setUserDetails({ lancamentos, metas, investimentos });
      setFilteredData(lancamentos);
    } catch (error) {
      console.error("Erro ao buscar dados do usuário:", error.message);
    }
  };

  useEffect(() => {
    if (showLinkClientsDialog) {
      fetchAllClients();
    }
  }, [showLinkClientsDialog]);

  const handleViewUser = async (userId) => {
    try {
      await fetchUserDetails(userId);
      setShowViewUserDialog(true);
      setStartDate(null);
      setEndDate(null);
    } catch (error) {
      console.error("Erro ao visualizar os detalhes do usuário:", error.message);
    }
  };

  const handleNewUser = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, newUser.email, newUser.password);
      const userId = userCredential.user.uid;

      const userRef = doc(firestore, "usuarios", userId);
      await setDoc(userRef, {
        name: newUser.name,
        email: newUser.email,
        role: newUser.role,
        createdAt: new Date().toISOString(),
        isBlocked: false,
      });

      const categoriasCollection = collection(userRef, "categorias");
      for (const categoria of categoriasPadrao) {
        await setDoc(doc(categoriasCollection, categoria.nome), categoria);
      }

      setUsuarios([...usuarios, { id: userId, ...newUser }]);
      setShowNewUserDialog(false);
      setNewUser({
        name: "",
        email: "",
        password: "",
        role: "cliente",
      });
    } catch (error) {
      console.error("Erro ao criar usuário:", error.message);
      alert("Erro ao criar usuário. Verifique os dados e tente novamente.");
    }
  };

  const handleUpdateUser = async () => {
    try {
      const userRef = doc(firestore, "usuarios", selectedUser.id);

      await updateDoc(userRef, {
        name: selectedUser.name,
        email: selectedUser.email,
        role: selectedUser.role,
      });

      if (selectedUser.role === "consultor" || selectedUser.role === "admin") {
        const consultorCollection = collection(userRef, "consultor");
        const snapshot = await getDocs(consultorCollection);

        if (snapshot.empty) {
          await setDoc(doc(consultorCollection, "default"), {
            description: "Coleção inicial para consultor",
            createdAt: new Date().toISOString(),
          });
        }
      }

      setUsuarios((prev) => prev.map((user) => (user.id === selectedUser.id ? selectedUser : user)));
      setShowEditUserDialog(false);
    } catch (error) {
      console.error("Erro ao atualizar usuário:", error.message);
      alert("Erro ao atualizar usuário. Verifique as permissões e tente novamente.");
    }
  };

  const handleLinkClients = async (user) => {
    try {
      const querySnapshot = await getDocs(collection(firestore, "usuarios"));
      const clients = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setAllClients(clients);

      const updatedUser = usuarios.find((u) => u.id === user.id) || user;
      setSelectedUser({
        ...updatedUser,
        linkedClients: updatedUser.linkedClients || [],
      });

      setShowLinkClientsDialog(true);
    } catch (error) {
      console.error("Erro ao carregar clientes:", error.message);
    }
  };

  const toggleBlockUser = async (user) => {
    try {
      const userRef = doc(firestore, "usuarios", user.id);
      await updateDoc(userRef, { isBlocked: !user.isBlocked });

      setUsuarios((prev) => prev.map((u) => (u.id === user.id ? { ...u, isBlocked: !u.isBlocked } : u)));
    } catch (error) {
      console.error("Erro ao bloquear/ativar usuário:", error.message);
      alert("Erro ao bloquear/ativar usuário. Tente novamente.");
    }
  };

  const confirmDeleteUser = async () => {
    try {
      const userId = selectedUser.id;

      const deleteSubcollections = async () => {
        const collectionsToDelete = ["categorias", "lancamentos", "metas", "investimentos"];
        for (const col of collectionsToDelete) {
          const colRef = collection(firestore, "usuarios", userId, col);
          const colSnapshot = await getDocs(colRef);
          for (const docSnap of colSnapshot.docs) {
            await deleteDoc(docSnap.ref);
          }
        }
      };

      await deleteSubcollections();
      await deleteDoc(doc(firestore, "usuarios", userId));
      setUsuarios((prev) => prev.filter((user) => user.id !== userId));
      setShowDeleteUserDialog(false);
    } catch (error) {
      console.error("Erro ao excluir usuário:", error.message);
      alert("Erro ao excluir usuário. Tente novamente.");
    }
  };

  const toggleClientLink = async (clientId) => {
    const isLinked = selectedUser?.linkedClients?.includes(clientId);

    if (isLinked) {
      const updatedClients = selectedUser.linkedClients.filter((id) => id !== clientId);
      setSelectedUser((prev) => ({
        ...prev,
        linkedClients: updatedClients,
      }));

      const consultorRef = doc(firestore, "usuarios", selectedUser.id);
      await updateDoc(consultorRef, {
        linkedClients: updatedClients,
      });

      const clientRef = doc(firestore, "usuarios", clientId);
      await updateDoc(clientRef, {
        linkedTo: null,
        linkedToName: null,
      });

      setAllClients((prev) =>
        prev.map((client) => (client.id === clientId ? { ...client, linkedTo: null, linkedToName: null } : client))
      );
    } else {
      const updatedClients = [...(selectedUser.linkedClients || []), clientId];
      setSelectedUser((prev) => ({
        ...prev,
        linkedClients: updatedClients,
      }));

      const consultorRef = doc(firestore, "usuarios", selectedUser.id);
      await updateDoc(consultorRef, {
        linkedClients: updatedClients,
      });

      const clientRef = doc(firestore, "usuarios", clientId);
      await updateDoc(clientRef, {
        linkedTo: selectedUser.id,
        linkedToName: selectedUser.name,
      });

      setAllClients((prev) =>
        prev.map((client) =>
          client.id === clientId ? { ...client, linkedTo: selectedUser.id, linkedToName: selectedUser.name } : client
        )
      );
    }
  };

  const saveLinkedClients = async () => {
    try {
      const consultorRef = doc(firestore, "usuarios", selectedUser.id);

      for (const clientId of selectedUser.linkedClients) {
        const clientRef = doc(firestore, "usuarios", clientId);
        await updateDoc(clientRef, {
          linkedTo: selectedUser.id,
          linkedToName: selectedUser.name,
        });
      }

      const allClientsRef = await getDocs(collection(firestore, "usuarios"));
      const allClientsData = allClientsRef.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      for (const client of allClientsData) {
        if (client.linkedTo === selectedUser.id && !selectedUser.linkedClients.includes(client.id)) {
          const clientRef = doc(firestore, "usuarios", client.id);
          await updateDoc(clientRef, {
            linkedTo: null,
            linkedToName: null,
          });
        }
      }

      const updatedClients = allClientsData;
      const updatedConsultor = usuarios.find((u) => u.id === selectedUser.id) || selectedUser;

      setAllClients(updatedClients);
      setSelectedUser(updatedConsultor);

      setShowLinkClientsDialog(false);
    } catch (error) {
      console.error("Erro ao salvar clientes vinculados:", error.message);
      alert("Erro ao salvar as alterações. Tente novamente.");
    }
  };

  const calculateTotal = (lancamentos) => {
    return lancamentos.reduce((total, lancamento) => {
      let valor = 0;
      try {
        const valorStr = lancamento.valor?.toString().trim() || "0";
        const cleanedValor = valorStr.replace(/R\$/g, "").replace(/\s/g, "").replace(",", ".");
        valor = parseFloat(cleanedValor);
        if (isNaN(valor)) valor = 0;
      } catch (error) {
        console.error(`Erro ao parsear valor: ${lancamento.valor}`, error);
        valor = 0;
      }
      return total + valor;
    }, 0);
  };

  const handleSearch = () => {
    let filtered = userDetails.lancamentos;

    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      if (start > end) {
        alert("A data inicial não pode ser maior que a data final.");
        return;
      }

      filtered = filtered.filter((lancamento) => {
        if (!lancamento.data) {
          console.log("Lançamento sem data:", lancamento);
          return false;
        }

        const [dia, mes, ano] = lancamento.data.split("/");
        const lancamentoDate = new Date(`${ano}-${mes}-${dia}T00:00:00`);
        if (isNaN(lancamentoDate.getTime())) {
          console.log("Data inválida no lançamento:", lancamento);
          return false;
        }

        return lancamentoDate >= start && lancamentoDate <= end;
      });
    }

    setFilteredData(filtered);

    if (filtered.length === 0 && startDate && endDate) {
      alert("Nenhum lançamento encontrado no período especificado.");
    }

    console.log("Filtered lancamentos after handleSearch:", filtered);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} px={1}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          centered
          variant="fullWidth"
          sx={{
            // container das abas (trilho)
            p: 0.5,
            mx: "auto",
            width: { xs: "100%", sm: "auto" },
            borderRadius: 9999,
            background: "rgba(255,255,255,0.65)",
            border: "1px solid rgba(30,136,229,0.15)", // azul bem suave
            boxShadow: "0 6px 18px rgba(30,136,229,0.08)",
            backdropFilter: "saturate(180%) blur(8px)",
            "& .MuiTabs-indicator": { display: "none" }, // sem linha
            // cada aba
            "& .MuiTab-root": {
              minHeight: 40,
              borderRadius: 9999,
              textTransform: "none",
              fontWeight: 700,
              fontSize: { xs: "0.9rem", md: "1rem" },
              px: { xs: 1.5, md: 2.5 },
              color: "#5E7FA3", // cinza-azulado para melhor leitura
              transition: "all .2s ease",
              "&:hover": {
                backgroundColor: "rgba(221,241,255,0.7)",
              },
              "&.Mui-selected": {
                color: "#1565D8", // azul do título, forte porém legível
                background: "linear-gradient(180deg, #E6F5FF 0%, #F4FAFF 100%)",
                border: "1px solid #BFE7FF",
                boxShadow: "0 6px 14px rgba(21,101,216,0.12), inset 0 -2px 0 rgba(21,101,216,0.06)",
              },
            },
          }}
        >
          <Tab label="Usuários" />
          <Tab label="Sistema" />
        </Tabs>
        <Divider />
        {tabIndex === 0 ? (
          <MDBox mt={3}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h5" mb={2}>
                  Lista de Usuários
                </MDTypography>

                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                  <TextField
                    label="Buscar por Nome ou E-mail"
                    variant="outlined"
                    size="small"
                    sx={{ width: "60%" }}
                    onChange={(e) => {
                      const value = e.target.value.toLowerCase();
                      setUsuariosFiltrados(
                        usuarios.filter(
                          (user) => user.name.toLowerCase().includes(value) || user.email.toLowerCase().includes(value)
                        )
                      );
                    }}
                  />

                  <MDButton
                    variant="gradient"
                    color="info"
                    startIcon={<AddIcon />}
                    onClick={() => setShowNewUserDialog(true)}
                  >
                    Adicionar Usuário
                  </MDButton>
                </MDBox>

                <Grid container spacing={2}>
                  {usuariosFiltrados.map((user) => (
                    <Grid item xs={12} sm={6} md={4} key={user.id}>
                      <MDBox
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-start"
                        p={2}
                        borderRadius="12px"
                        sx={{
                          backgroundColor: darkMode ? "#444" : "#f9f9f9",
                          color: darkMode ? "#fff" : "#000",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                          transition: "background-color 0.3s, color 0.3s",
                          wordWrap: "break-word",
                        }}
                      >
                        <MDTypography
                          mb={2}
                          sx={{
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            wordBreak: "break-word",
                          }}
                        >
                          <strong>Nome:</strong> {user.name} <br />
                          <strong>Email:</strong> {user.email} <br />
                          <strong>Função:</strong> {user.role || "Cliente"} <br />
                          <strong>Status:</strong> {user.isBlocked ? "Bloqueado" : "Ativo"}
                        </MDTypography>

                        <MDBox display="flex" justifyContent="flex-start" flexWrap="wrap" gap={1}>
                          <IconButton
                            color="warning"
                            onClick={() => {
                              setSelectedUser(user);
                              setShowEditUserDialog(true);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            color="error"
                            onClick={() => {
                              setSelectedUser(user);
                              setShowDeleteUserDialog(true);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                          <IconButton
                            color="info"
                            onClick={() => {
                              setSelectedUser(user);
                              handleViewUser(user.id);
                            }}
                          >
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton
                            color={user.isBlocked ? "warning" : "success"}
                            onClick={() => toggleBlockUser(user)}
                          >
                            <BlockIcon />
                          </IconButton>
                          {user.role && (user.role === "consultor" || user.role === "admin") && (
                            <IconButton color="secondary" onClick={() => handleLinkClients(user)}>
                              <AddIcon />
                            </IconButton>
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                  ))}
                </Grid>
              </MDBox>
            </Card>
          </MDBox>
        ) : (
          <MDBox mt={3}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h5" mb={2}>
                  Configurações do Sistema
                </MDTypography>
              </MDBox>
            </Card>
          </MDBox>
        )}
      </MDBox>

      <Dialog
        open={showViewUserDialog}
        onClose={() => setShowViewUserDialog(false)}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: darkMode ? "#333" : "#fff",
            color: darkMode ? "#fff" : "#000",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: darkMode ? "#444" : "#f5f5f5",
            color: darkMode ? "#fff" : "#000",
            textAlign: "center",
            padding: "16px",
            fontWeight: "bold",
          }}
        >
          {selectedUser?.name ? selectedUser.name : "Visualizar Usuário"}
        </DialogTitle>
        <DialogContent
          style={{
            backgroundColor: darkMode ? "#333" : "#fff",
            color: darkMode ? "#fff" : "#000",
          }}
        >
          <Tabs
            value={modalTabIndex}
            onChange={(e, value) => setModalTabIndex(value)}
            centered
            sx={{
              "& .MuiTabs-indicator": {
                display: "none",
              },
              "& .MuiTab-root": {
                fontSize: "0.9rem",
                fontWeight: "medium",
                textTransform: "none",
                py: 1,
                px: 2,
                borderRadius: "8px",
                color: "grey.600",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              },
              "& .MuiTab-root.Mui-selected": {
                color: "primary.main",
                backgroundColor: "rgba(25, 118, 210, 0.1)",
                fontWeight: "bold",
              },
            }}
          >
            <Tab label="Lançamentos" />
            <Tab label="Metas" />
            <Tab label="Investimentos" />
          </Tabs>

          {modalTabIndex === 0 && (
            <MDBox mt={2}>
              <MDTypography
                variant="h6"
                gutterBottom
                style={{
                  color: darkMode ? "#fff" : "#000",
                }}
              >
                Lançamentos
              </MDTypography>

              <MDBox display="flex" gap={2} mb={2} alignItems="center">
                <TextField
                  label="Data Início"
                  type="date"
                  value={startDate || ""}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ width: "200px" }}
                />
                <TextField
                  label="Data Fim"
                  type="date"
                  value={endDate || ""}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ width: "200px" }}
                />
                <MDButton onClick={handleSearch} color="info">
                  Filtrar
                </MDButton>
              </MDBox>

              {userDetails.lancamentos.length > 0 ? (
                <MDBox>
                  {["Receita", "Despesa Fixa", "Despesa Variável"].map((tipo) => {
                    const filteredLancamentos = filteredData.filter((lancamento) => {
                      const matchesType = lancamento.tipo === tipo;
                      return matchesType;
                    });

                    const total = calculateTotal(filteredLancamentos);
                    const totalFormatado = `R$ ${total.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;

                    return (
                      <Accordion key={tipo} defaultExpanded={true}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          sx={{
                            backgroundColor: darkMode ? "#444" : "#f5f5f5",
                            color: darkMode ? "#fff" : "#000",
                          }}
                        >
                          <MDTypography variant="h6">
                            {tipo === "Receita"
                              ? "Receitas"
                              : tipo === "Despesa Fixa"
                              ? "Despesas Fixas"
                              : "Despesas Variáveis"}{" "}
                            - Total: {totalFormatado}
                          </MDTypography>
                        </AccordionSummary>
                        <AccordionDetails>
                          {filteredLancamentos.length > 0 ? (
                            (() => {
                              const categoriasUnicas = [...new Set(filteredLancamentos.map((l) => l.categoria))];
                              return categoriasUnicas.map((categoria) => {
                                const lancamentosCategoria = filteredLancamentos.filter(
                                  (l) => l.categoria === categoria
                                );
                                return (
                                  <MDBox key={categoria} ml={2} mb={2}>
                                    <MDTypography
                                      variant="subtitle1"
                                      gutterBottom
                                      style={{
                                        color: darkMode ? "#ddd" : "#333",
                                      }}
                                    >
                                      {categoria || "Sem categoria"}
                                    </MDTypography>
                                    <table
                                      style={{
                                        width: "100%",
                                        textAlign: "center",
                                        borderCollapse: "collapse",
                                        color: darkMode ? "#fff" : "#000",
                                        marginLeft: "16px",
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          <th style={{ borderBottom: "1px solid #555", padding: "8px" }}>Data</th>
                                          <th style={{ borderBottom: "1px solid #555", padding: "8px" }}>Categoria</th>
                                          <th style={{ borderBottom: "1px solid #555", padding: "8px" }}>
                                            Forma de Pagamento
                                          </th>
                                          <th style={{ borderBottom: "1px solid #555", padding: "8px" }}>Valor</th>
                                          <th style={{ borderBottom: "1px solid #555", padding: "8px" }}>Status</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {lancamentosCategoria.map((lancamento, index) => {
                                          const dataFormatada = lancamento.data || "Não informado";
                                          const valorFormatado = lancamento.valor || "R$ 0,00";

                                          return (
                                            <tr key={index}>
                                              <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                                                {dataFormatada}
                                              </td>
                                              <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                                                {lancamento.categoria || "Não informado"}
                                              </td>
                                              <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                                                {lancamento.formaPagamento || "Não informado"}
                                              </td>
                                              <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                                                {valorFormatado}
                                              </td>
                                              <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                                                Pago
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </MDBox>
                                );
                              });
                            })()
                          ) : (
                            <MDTypography style={{ color: darkMode ? "#ddd" : "#000", marginLeft: "16px" }}>
                              Nenhum lançamento encontrado com os filtros aplicados.
                            </MDTypography>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                  {(() => {
                    const totalReceitas = calculateTotal(filteredData.filter((l) => l.tipo === "Receita"));
                    const totalDespesasFixas = calculateTotal(filteredData.filter((l) => l.tipo === "Despesa Fixa"));
                    const totalDespesasVariaveis = calculateTotal(
                      filteredData.filter((l) => l.tipo === "Despesa Variável")
                    );
                    const saldoFinal = totalReceitas - (totalDespesasFixas + totalDespesasVariaveis);

                    return (
                      <MDTypography variant="h6" style={{ color: darkMode ? "#fff" : "#000", marginTop: "16px" }}>
                        Saldo Final: R$ {saldoFinal.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                      </MDTypography>
                    );
                  })()}
                </MDBox>
              ) : (
                <MDTypography style={{ color: darkMode ? "#ddd" : "#000" }}>Nenhum lançamento encontrado.</MDTypography>
              )}
            </MDBox>
          )}

          {modalTabIndex === 1 && (
            <MDBox mt={2}>
              <MDTypography
                variant="h6"
                gutterBottom
                style={{
                  color: darkMode ? "#fff" : "#000",
                }}
              >
                Metas
              </MDTypography>
              {userDetails.metas.length > 0 ? (
                <table
                  style={{
                    width: "100%",
                    textAlign: "center",
                    borderCollapse: "collapse",
                    color: darkMode ? "#fff" : "#000",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Meta
                      </th>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Valor
                      </th>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Total Aportado
                      </th>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Prazo
                      </th>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Dias Restantes
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {userDetails.metas.map((meta, index) => {
                      const totalAportado = meta.aportesRegistrados
                        ? meta.aportesRegistrados.reduce((total, aporte) => total + aporte, 0)
                        : 0;

                      const diasRestantes = meta.prazo
                        ? Math.max(
                            Math.ceil((new Date(meta.prazo).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)),
                            0
                          )
                        : null;

                      return (
                        <tr key={index}>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            {meta.nome || "Não informado"}
                          </td>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            R$ {meta.valor?.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) || "0,00"}
                          </td>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            R$ {totalAportado.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                          </td>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            {meta.prazo ? new Date(meta.prazo).toLocaleDateString("pt-BR") : "Não informado"}
                          </td>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            {diasRestantes !== null ? `${diasRestantes} dias` : "Não informado"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <MDTypography style={{ color: darkMode ? "#ddd" : "#000" }}>Nenhuma meta encontrada.</MDTypography>
              )}
            </MDBox>
          )}

          {modalTabIndex === 2 && (
            <MDBox mt={2}>
              <MDTypography
                variant="h6"
                gutterBottom
                style={{
                  color: darkMode ? "#fff" : "#000",
                }}
              >
                Investimentos
              </MDTypography>
              {userDetails.investimentos.length > 0 ? (
                <table
                  style={{
                    width: "100%",
                    textAlign: "center",
                    borderCollapse: "collapse",
                    color: darkMode ? "#fff" : "#000",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Categoria
                      </th>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Ativo
                      </th>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Corretora
                      </th>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Data
                      </th>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Quantidade
                      </th>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Valor Aplicado
                      </th>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Indexador
                      </th>
                      <th
                        style={{ borderBottom: "1px solid", borderColor: darkMode ? "#555" : "#ddd", padding: "8px" }}
                      >
                        Taxa
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {userDetails.investimentos.map((investimento, index) => {
                      const valorAplicado = investimento.valorAplicado || 0;

                      return (
                        <tr key={index}>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            {investimento.categoria || "Não informado"}
                          </td>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            {investimento.ativo || "Não informado"}
                          </td>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            {investimento.corretora || "Não informado"}
                          </td>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            {investimento.data
                              ? new Date(investimento.data).toLocaleDateString("pt-BR")
                              : "Não informado"}
                          </td>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            {investimento.quantidade || "0"}
                          </td>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            R$ {valorAplicado.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                          </td>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            {investimento.indexador || "Não informado"}
                          </td>
                          <td style={{ padding: "8px", color: darkMode ? "#ddd" : "#000" }}>
                            {investimento.taxa || "0"}%
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <MDTypography style={{ color: darkMode ? "#ddd" : "#000" }}>
                  Nenhum investimento encontrado.
                </MDTypography>
              )}
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton onClick={exportToPDF} color="info">
            Exportar para PDF
          </MDButton>
          <MDButton onClick={() => setShowViewUserDialog(false)} color="error">
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog open={showNewUserDialog} onClose={() => setShowNewUserDialog(false)}>
        <DialogTitle>Adicionar Usuário</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Nome"
            value={newUser.name}
            onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="E-mail"
            value={newUser.email}
            onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Senha"
            type="password"
            value={newUser.password}
            onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
            margin="normal"
          />
          <Select
            fullWidth
            value={newUser.role}
            onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
            margin="normal"
          >
            <MenuItem value="cliente">Cliente</MenuItem>
            <MenuItem value="admin">Administrador</MenuItem>
            <MenuItem value="consultor">Consultor</MenuItem>
          </Select>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setShowNewUserDialog(false)} color="secondary">
            Cancelar
          </MDButton>
          <MDButton onClick={handleNewUser} color="info">
            Criar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showEditUserDialog}
        onClose={() => setShowEditUserDialog(false)}
        PaperProps={{
          sx: (theme) => ({
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
            boxShadow: theme.shadows[5],
            borderRadius: "12px",
          }),
        }}
      >
        <DialogTitle>Editar Usuário</DialogTitle>
        <DialogContent>
          <MDBox component="form">
            <TextField
              fullWidth
              label="Nome"
              value={selectedUser?.name || ""}
              onChange={(e) => setSelectedUser((prev) => ({ ...prev, name: e.target.value }))}
              margin="normal"
              variant="outlined"
            />
            <TextField
              fullWidth
              label="E-mail"
              value={selectedUser?.email || ""}
              onChange={(e) => setSelectedUser((prev) => ({ ...prev, email: e.target.value }))}
              margin="normal"
              variant="outlined"
            />
            <Select
              fullWidth
              value={selectedUser?.role || ""}
              onChange={(e) => setSelectedUser((prev) => ({ ...prev, role: e.target.value }))}
              margin="normal"
              variant="outlined"
            >
              <MenuItem value="cliente">Cliente</MenuItem>
              <MenuItem value="admin">Administrador</MenuItem>
              <MenuItem value="consultor">Consultor</MenuItem>
            </Select>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setShowEditUserDialog(false)} color="secondary">
            Cancelar
          </MDButton>
          <MDButton onClick={handleUpdateUser} color="info">
            Atualizar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showDeleteUserDialog}
        onClose={() => setShowDeleteUserDialog(false)}
        PaperProps={{
          sx: (theme) => ({
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
            boxShadow: theme.shadows[5],
            borderRadius: "12px",
          }),
        }}
      >
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <MDTypography>
            Tem certeza de que deseja excluir o usuário <strong>{selectedUser?.name || "desconhecido"}</strong>? Essa
            ação não pode ser desfeita.
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setShowDeleteUserDialog(false)} color="secondary">
            Cancelar
          </MDButton>
          <MDButton onClick={confirmDeleteUser} color="error">
            Excluir
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showLinkClientsDialog}
        onClose={() => setShowLinkClientsDialog(false)}
        PaperProps={{
          sx: {
            backgroundColor: darkMode ? "#333" : "#fff",
            color: darkMode ? "#fff" : "#000",
            boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>Vincular Clientes ao Consultor</DialogTitle>
        <DialogContent>
          <MDTypography variant="body2" mb={2}>
            Vinculando clientes ao consultor: <strong>{selectedUser?.name || "Consultor"}</strong>
          </MDTypography>
          <MDBox>
            {allClients.length > 0 ? (
              allClients.map((cliente) => {
                const isLinkedToCurrent = selectedUser?.linkedClients?.includes(cliente.id);
                const isLinkedToAnother = cliente.linkedTo && cliente.linkedTo !== selectedUser.id;

                return (
                  <MDBox key={cliente.id} display="flex" alignItems="center" mb={2}>
                    <TextField
                      fullWidth
                      disabled
                      value={cliente.name || cliente.email}
                      variant="outlined"
                      margin="normal"
                      sx={{ mr: 2 }}
                    />
                    {isLinkedToAnother ? (
                      <MDButton variant="contained" color="warning" disabled>
                        Vinculado a {cliente.linkedToName || "Outro"}
                      </MDButton>
                    ) : (
                      <MDButton
                        variant={isLinkedToCurrent ? "contained" : "outlined"}
                        color={isLinkedToCurrent ? "error" : "success"}
                        onClick={() => toggleClientLink(cliente.id)}
                      >
                        {isLinkedToCurrent ? "Desvincular" : "Vincular"}
                      </MDButton>
                    )}
                  </MDBox>
                );
              })
            ) : (
              <MDTypography style={{ color: darkMode ? "#ddd" : "#000" }}>Nenhum cliente encontrado.</MDTypography>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setShowLinkClientsDialog(false)} color="secondary">
            Cancelar
          </MDButton>
          <MDButton onClick={saveLinkedClients} color="info">
            Salvar
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default PainelAdmin;
